import { type ReactNode } from 'react';
import { IconCurrencyRubel } from '@tabler/icons-react';
import { Currency } from '../model/currency';

const currenciesMap: Partial<Record<Currency, ReactNode>> = {
    [Currency.CURRENCY_RUB]: <IconCurrencyRubel size={16} />,
};

export const getCurrencyIcon = (currency?: Currency): ReactNode => {
    if (!currency) {
        return null;
    }

    return currenciesMap[currency];
};
